import React, {useState} from 'react';
import Box from '@mui/material/Box';
import Autocomplete from '@mui/material/Autocomplete';
import MDInput from "../../../materialDashboard/components/MDInput";
import {useRegionQuery, useRegionsInfiniteQuery} from "./query";
import {useTranslation} from "react-i18next";
import {getScrollHandler, LoadingAdornment} from "../utils";
import {debounce} from "../../../utils/debounce";


const RegionAutocomplete = ({MDInputProps={}, value, onChange, ...props}) => {
    const [search, setSearch] = useState("");
    const regionsQuery = useRegionsInfiniteQuery({search: search, order_by: "name"});
    const regionQuery = useRegionQuery(value, {staleTime: Infinity});
    const regions = regionsQuery.data?.pages?.flatMap((page) => page.items) ?? [];
    const selectedRegion = regions.data?.find(region => region.id === value) ?? regionQuery.data;
    const {t} = useTranslation("inputs");

    const options = [
        ...(selectedRegion ? [selectedRegion] : []),
        ...regions.filter((s) => !selectedRegion || selectedRegion.id !== s.id),
    ]

    const handleSearchChange = debounce((value) => {
        setSearch(value);
    }, 300);

    return (
        <Autocomplete
            fullWidth
            isOptionEqualToValue={(option, value) => {
                return option.id === value.id
            } }
            options={options}
            filterOptions={(x) => x}
            autoHighlight
            getOptionLabel={(option) => option.name ?? ""}
            onChange={(event, newValue) => onChange(newValue?.id)}
            onClose={() => handleSearchChange("")}
            value={selectedRegion ?? null}
            loading={regions.isLoading || regionQuery.isFetching}
            renderOption={(props, option) => {
                const { key, ...optionProps } = props;
                return (
                    <Box key={key} component="li" {...optionProps}>
                        {option.name}
                    </Box>
                );
            }}
            ListboxProps={{onScroll: getScrollHandler(regionsQuery)}}
            renderInput={(params) => (
                <MDInput
                    {...params}
                    onChange={(e) => handleSearchChange(e.target.value)}
                    label={t("regionAutocomplete.label")}
                    inputProps={{
                        ...params.inputProps,
                        autoComplete: 'off', // disable autocomplete and autofill
                    }}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (<LoadingAdornment infiniteQuery={regionsQuery} params={params}/> ),
                    }}
                    variant="standard"
                    {...MDInputProps}
                />
            )}
            {...props}
        />
    );
}

export default RegionAutocomplete;